//
// Remark: Requiring this file will use the "safe" colors API which will not touch String.prototype
//
//   var colors = require('colors/safe);
//   colors.red("foo")
//
//
var colors = require('./lib/colors');
module['exports'] = colors;


/*****************
 ** WEBPACK FOOTER
 ** ./~/colors/safe.js
 ** module id = 245
 ** module chunks = 0
 **/